import { FC } from 'react'
import { Paper, Stack, SxProps, Theme, Typography } from '@mui/material'
import { dashboardIcons } from '../../../utils/constants'
import { DashboardStatus } from '../../../types/dashboard.type'

const AdssDashboardField: FC<DashboardStatus> = ({ label, value, color = null, invert = false, icon = null }) => {
  const sx: SxProps<Theme> = { px: 1.5, py: 1 }

  const Icon = icon ? dashboardIcons[icon] : null

  if (color) {
    if (invert) {
      sx.background = (t) => t.palette[color][t.palette.mode === 'light' ? 'light' : 'main'] + ' !important'
    } else {
      sx.color = `${color}.main`
    }
  }

  return (
    <>
      <Paper sx={sx}>
        <Typography color="text.secondary">{label}</Typography>
        <Typography variant="h6" fontWeight="bold">
          {Icon && <Icon fontSize="small" sx={{ fontSize: '1.4em', verticalAlign: 'bottom', mr: 0.5 }} />}
          {value}
        </Typography>
      </Paper>
    </>
  )
}

interface IProps {
  fields?: DashboardStatus[]
}

const StatusPanel: FC<IProps> = ({ fields }) => {
  return <Stack spacing={2}>{fields?.map((f) => <AdssDashboardField key={f.label} {...f} />)}</Stack>
}

export default StatusPanel
